/* eslint-disable camelcase */
import Vue from 'vue'
import moment from 'moment'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'

import {
  required,
  oneOf,
  email,
  min_value,
  max_value,
  integer,
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'This field is required',
})

extend('oneOf', {
  ...oneOf,
  message: 'This option is not valid',
})

extend('email', {
  ...email,
  message: 'Email not valid',
})

extend('min_bike_value', {
  ...min_value,
  message: 'Minimum bike value is: 400',
})

extend('max_bike_value', {
  ...max_value,
  message: 'Maximum bike value is: 15000',
})

extend('min_age', {
  ...min_value,
  message: 'Minimum age is 16',
})
extend('max_age', {
  ...max_value,
  message: 'Maximum age is 120',
})

extend('min_day', {
  ...min_value,
  message: 'Day should be between 1 and 31',
})
extend('max_day', {
  validate(value) {
    return value.length <= 2 && Number(value) <= 31
  },
  message: 'Day should be between 1 and 31',
})

extend('min_month', {
  ...min_value,
  message: 'Month should be between 1 and 12',
})
extend('max_month', {
  validate(value) {
    return value.length <= 2 && Number(value) <= 12
  },
  message: 'Month should be between 1 and 12',
})
extend('valid_year', {
  validate(value) {
    return value.length === 4
  },
  message: 'Year is not valid',
})
extend('min_year', {
  validate(value) {
    const age = moment().diff(`${value}-01-01`, 'years')
    return Number(age) >= 16
  },
  message: 'Min age is 16 years',
})

extend('mаx_year', {
  validate(value) {
    const age = moment().diff(`${value}-01-01`, 'years')
    return Number(age) < 120
  },
  message: 'too old',
})

extend('integer', {
  ...integer,
  message: 'This field is numeric',
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match',
})

extend('birth_date', {
  validate(value) {
    return value <= moment().subtract(16, 'years').toDate()
  },
  message: 'Min age is 16 years',
})

extend('credit_card', {
  validate: (value) => {
    const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/
    const mastercardRegEx = /^(?:5[1-5][0-9]{14})$/
    const amexpRegEx = /^(?:3[47][0-9]{13})$/
    const discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/
    let isValid = false
    if (visaRegEx.test(value)) {
      isValid = true
    } else if (mastercardRegEx.test(value)) {
      isValid = true
    } else if (amexpRegEx.test(value)) {
      isValid = true
    } else if (discovRegEx.test(value)) {
      isValid = true
    }
    return isValid
  },
  message: 'Please enter a valid credit card',
})

extend('cvv', {
  validate: (value) => {
    const cvvRegEx = /^[0-9]{3,4}$/
    let isValid = false
    if (cvvRegEx.test(value)) {
      isValid = true
    }
    return isValid
  },
  message: 'Please enter a valid cvv',
})

extend('sortcode', {
  validate: (value) => {
    const sortCodeRegEx = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/
    let isValid = false
    if (sortCodeRegEx.test(value)) {
      isValid = true
    }
    return isValid
  },
  message: 'Please enter a valid sortcode',
})

extend('adddressLookUp', {
  validate: (value) => {
    let isValid = false
    if (
      value.house !== '' &&
      value.street !== '' &&
      value.city !== '' &&
      value.county !== '' &&
      value.postcode !== ''
    ) {
      isValid = true
    }
    return isValid
  },
  message: 'Please select adress',
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
